var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#question-line_svg__clip0_2620_107154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29.333C8.634 29.333 2.665 23.364 2.665 16S8.636 2.667 15.999 2.667c7.364 0 13.334 5.969 13.334 13.333s-5.97 13.333-13.334 13.333zm0-2.666a10.667 10.667 0 100-21.334 10.667 10.667 0 000 21.334zM14.665 20h2.667v2.667h-2.667V20zm2.667-2.193v.86h-2.667v-2a1.334 1.334 0 011.333-1.334 2 2 0 10-1.961-2.392l-2.616-.524a4.669 4.669 0 115.91 5.39z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "question-line_svg__clip0_2620_107154"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgQuestionLine;